import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration
// Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyC8cKCe98vWT1rMsNi6fGmVIYOaGaobJpE",
  authDomain: "epoch-d2996.firebaseapp.com",
  projectId: "epoch-d2996",
  storageBucket: "epoch-d2996.firebasestorage.app",
  messagingSenderId: "829884606595",
  appId: "1:829884606595:web:04f2edb81318bdfb0713b6",
  measurementId: "G-RRJFZTJ1NY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Configure Google Auth Provider for better popup handling
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Add scopes if needed
googleProvider.addScope('email');
googleProvider.addScope('profile');

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;
